export function onPressEscape( callback: EventListener ) {
    document.addEventListener( 'keyup', ( event: KeyboardEvent ) => {
        if ( event.key === 'Escape' ) {
            callback( event );
        }
    } );
}
